export const VERMONT_CODE = "VT";
export const NORTH_DAKOTA_CODE = "ND";
export const US_CODE = "US";

const Regions = [
    { regionCode: US_CODE, regionName: "Americas" },
    { regionCode: "Europe", regionName: "Europe" },
    { regionCode: "Middleeast", regionName: "Middle East" },
    { regionCode: "Asia", regionName: "Asia" },
    { regionCode: "Africa", regionName: "Africa" },
    { regionCode: "Canada", regionName: "Canada" },
    { regionCode: "Japan", regionName: "Japan" }
];

export default Regions;
